import permission from './permission';//权限指令
// 自定义指令
const directives = {
    permission,
}
 
// 批量注册指令
export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key])
    })
  },
}